import { jsx as _jsx } from "react/jsx-runtime";
import { NodeTypeModalForm } from '../EntityModalForms/NodeTypeModalForm';
function EditNodeTypeModal({ isOpen, onClose, onUpdate, nodeType, isLoading }) {
    return (_jsx(NodeTypeModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onUpdate, isLoading: isLoading, mode: "edit", nodeType: nodeType, title: "Edit Node Type", submitIdleLabel: "Update", submitBusyLabel: "Updating..." }));
}
export default EditNodeTypeModal;
